export default __webpack_public_path__ + "2a9bbd96b8b558c28cc25863ba23f62e.ttf";